import "./FoodBanners.css";

export default function FoodBanners({ banners, ordem }) {
  if (!banners || banners.length === 0) return null;

  const bannerFood = banners.find(
    (banner) =>
      banner.localizacao === "foodbanner" && banner.ordem === ordem
  );

  if (!bannerFood) return null;

  return (
    <section className="foodpart01-banner">
      <img
        src={bannerFood.imagem}
        alt="Banner promocional"
      />
    </section>
  );
}
